import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import padStart from 'lodash/padStart';
import { shallowEqual, shallowCompare } from 'app-source/utils/shallowEqual';
import CardActions from '@material-ui/core/CardActions';
import CloseIcon from '@material-ui/icons/Close';
import Hidden from '@material-ui/core/Hidden';
import classNames from 'classnames';

const styles = () => ({
  bold: {
    fontWeight: 800,
  },
  header: {
    paddingBottom: 0,
    marginTop: '-20px',
    paddingRight: '10px',
  },
  closeIcon: {
    position: 'absolute',
    right: '6px',
    top: '6px',
    color: '#2C2C2C',
    height: '16px',
  },
  overline: {
    letterSpacing: 1,
    opacity: 0.3,
  },
  title: {
    fontWeight: 'bold',
    lineHeight: 1.3,
  },
});

class TriviaFormHeaderComponent extends Component {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    title: PropTypes.string,
    timeRemainingToAnswer: PropTypes.number,
    answerTimeout: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {
    title: '',
    answerTimeout: 10000,
    timeRemainingToAnswer: 10000,
  };

  state = {
    mainColor: 'primary',
    progressValue: 0,
  };

  static getDerivedStateFromProps(props, state) {
    const { timeRemainingToAnswer, answerTimeout } = props;

    const isPastHalf = timeRemainingToAnswer < Math.ceil(answerTimeout / 2);

    const mainColor = isPastHalf ? 'secondary' : 'primary';
    const progressValue = (100 * timeRemainingToAnswer) / answerTimeout;

    let updatedState = {
      mainColor,
      progressValue,
    };

    if (shallowCompare(state, updatedState)) {
      updatedState = null;
    }
    return updatedState;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this, nextProps, nextState, {
      propsSelectOptions: { omit: ['classes'] },
    });
  }

  render() {
    const { classes, title, timeRemainingToAnswer, onClose } = this.props;

    const { mainColor, progressValue } = this.state;

    return (
      <Fragment>
        <Hidden smDown implementation="css">
          <LinearProgress variant="determinate" color={mainColor} value={progressValue} />
        </Hidden>
        <CardActions>
          <CloseIcon onClick={onClose} className={classes.closeIcon} />
        </CardActions>

        <CardHeader
          avatar={
            <Typography variant="h5" color={mainColor} className={classes.bold}>
              {padStart(Math.round(timeRemainingToAnswer / 1000).toString(10), 2, '0')}
            </Typography>
          }
          title={
            <Typography variant="overline" className={classNames(classes.overline, classes.title)}>
              Trivia
            </Typography>
          }
          subheader={
            <Typography variant="h6" className={classes.title}>
              {title}
            </Typography>
          }
          className={classes.header}
          classes={{ title: classes.bold }}
        />
      </Fragment>
    );
  }
}

export const TriviaFormHeader = withStyles(styles)(TriviaFormHeaderComponent);
